import User from "../../models/User";
import {
  getToken,
  setToken,
  removeToken
} from "@/utils/auth";

const state = {
  user: {
    id: null,
    username: null,
    super_manager: 0,
    mobile: null,
    sex: 0,
    token: null,
    email: null,

    roles: []
  },
  token: getToken()
};

const mutations = {
  setUser: (state, user) => {
    let stateUser = state.user;
    Object.keys(stateUser).forEach(stateKey => {
      Object.keys(user).forEach(userKey => {
        if (userKey == stateKey) {
          stateUser[stateKey] = user[userKey];
        }
      });
    });
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  }
};

const actions = {
  setUser({
    commit,
    state
  }, user) {
    commit("SET_TOKEN", user.token);
    setToken(user.token);
    commit("setUser", user);
  },
  Login({
    commit,
    state
  }, user) {},
  GetInfo({
    commit,
    state
  }) {
    if (state.user.id) {
      return new Promise((resolve, reject) => {
        if (state.user.id) {
          resolve();
        } else {
          reject();
        }
      });
    } else {
      return new Promise((resolve, reject) => {
        new User().info().then(res => {
          commit("SET_TOKEN", res.data.token)
          setToken(res.data.token)
          commit("setUser", res.data)
          resolve()
        }).catch(e => {
          reject()
        });
      });
    }
  },
  FedLogOut({
    commit,
    state
  }) {
    commit("SET_TOKEN", null), removeToken();
    commit("setUser", {
      id: null,
      user_name: null,
      super_manager: 0,
      mobile: null,
      sex: 0,
      token: null,
      email: null,

      roles: []
    });
  }
};

const getters = {
  user: state => state.user,
  token: state => state.token
};

export default {
  state,
  mutations,
  actions,
  getters
};